<template>
  <footer>
    Refait avec amour le Tusmo de
    <a href="https://x.com/Neurosis_44" target="_blank">Neurosis_44</a> ♡
  </footer>
</template>

<script>
export default {};
</script>

<style scoped>
footer {
  font-size: 13px;
  color: white;

  position: fixed;
  height: 50px;
  /* background-color: red; */
  bottom: 0px;
  left: 0px;
  right: 0px;
  margin-bottom: 0px;
  margin: 0 auto;
}

footer a:link {
  color: rgb(247, 183, 53);
  background-color: transparent;
  text-decoration: none;
}

footer a:visited {
  color: rgb(247, 183, 53);
  background-color: transparent;
  text-decoration: none;
}

footer a:hover {
  color: rgb(219, 58, 52);
  background-color: transparent;
}
</style>